module.exports = __webpack_public_path__ + "img/25.8ce561f2.jpg";